import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { getEnv } from './getEnv';

const isProduction = process.env.NODE_ENV === 'production';

const sampleRate = isProduction ? 0.2 : 1.0;

Sentry.init({
  enabled: isProduction,

  dsn: 'https://a24da7c986be9ef5a82676d155a7bc2e@o4508087709335552.ingest.us.sentry.io/4509681174052864',
  environment: getEnv(),

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  tracesSampleRate: sampleRate,
  profilesSampleRate: sampleRate,

  tracePropagationTargets: ['localhost', /^\//],
});
